import React, { createContext, useContext, useEffect, useState } from 'react'
// import {AuthContext} from '../auth/AuthContext';
import axiosInstance from '../utils/RequestsQueue';


export const StatsContext = createContext()

export function StatsProvider({ children }) {
  const currentUser = JSON.parse(sessionStorage.getItem('MazGuardCurrentUser'))
  const [stats, setStats] = useState(null)
    const [statsLoading, setStatsLoading] = useState(false)
    // console.log(currentUser?.id, currentUser?.id)

  async function fetchStats(){
          setStatsLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/stats/overview${(!!currentUser && currentUser?.id) ? `/${currentUser?.id}` : ''}`,
                method:"GET",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                //   Authorization: `Bearer ${authToken}`
                },
                // data:formData
              })
              // console.log('Response:',response?.data)
              setStats(response?.data?.data)
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              return error?.response?.data
          } finally {
              setStatsLoading(false)
          }
        
      }
  useEffect(() => {
          // Fetch once immediately
          fetchStats();
        
          // Set interval to fetch every 5 minutes (300,000 ms)
          const intervalId = setInterval(() => {
            fetchStats();
          }, 5 * 60 * 1000); // 5 minutes
        
          // Cleanup on unmount
          return () => clearInterval(intervalId);
        }, []); 



  const contextData = {
    stats,
    setStats,
    fetchStats,
    statsLoading,
    setStatsLoading,
  }
  return (
    <StatsContext.Provider value={contextData}>
      {children}
    </StatsContext.Provider>
  )
}
